import type { RouteRecordRaw } from 'vue-router'
import { route } from '@/router/utils'
import type { Options } from '@/router'
import { i18n } from '@/i18n'

const NOTIFICATIONS_BASE = 'cabinet:notifications'
const p = (name: string) => NOTIFICATIONS_BASE + ':' + name

export const NOTIFICATIONS_VIEW_NAME = p('view')

const NotificationsView = () => import('./views/Notifications.vue')

const BASE_MODEL_NAME = 'notifications/'

export function createRoutes(options: Options): RouteRecordRaw[] {
  const { t: $t } = i18n.global
  const { app } = options
  app.config.globalProperties.$router_notifications_view_name = NOTIFICATIONS_VIEW_NAME

  return [
    route(
      'list/',
      NotificationsView,
      NOTIFICATIONS_VIEW_NAME,
      {
        meta: {
          title: () => $t('Сповіщення'),
        },
      }),
    
  ]
}



export { BASE_MODEL_NAME, NOTIFICATIONS_BASE }